'use client';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { BlazonWhiteIcon, Niras } from './icons';
import { siteConfig } from '@/config/site';
import { MenuWithItems, NavItemWithTranslates } from '@/types/modelTypes';
import flagEU from './../../../public/files/images/flags/european-union-50.png';
import flagUA from './../../../public/files/images/flags/ukraine-50.png';
import NextLink from "next/link";
import { ThemeSwitch } from './theme-switch';
import { useSession } from 'next-auth/react';
import SignOutButton from './auth/SignOutButton';
import Link from 'next/link';

const navigation = {
    solutions: [
        { name: 'Programs', href: '#' },
        { name: 'Financing', href: '#' },
        { name: 'Analytics', href: '#' },

        { name: 'Commerce', href: '#' },
        { name: 'Insights', href: '#' },
    ],
    support: [
        { name: 'Submit ticket', href: '#' },
        { name: 'Documentation', href: '#' },
        { name: 'Guides', href: '#' },
    ],
    company: [
        { name: 'About', href: '#' },
        { name: 'Blog', href: '#' },
        { name: 'Jobs', href: '#' },
        { name: 'Press', href: '#' },
    ],
    legal: [
        { name: 'Terms of service', href: '#' },
        { name: 'Privacy policy', href: '#' },
        { name: 'License', href: '#' },
    ],
    social: [
        {
            name: 'Facebook',
            href: '#',
            brandColor: '#1877F2',
            icon: (props: any) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        // {
        //     name: 'Instagram',
        //     href: '#',
        //     icon: (props: any) => (
        //         <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
        //             <path
        //                 fillRule="evenodd"
        //                 d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
        //                 clipRule="evenodd"
        //             />
        //         </svg>
        //     ),
        // },
        // {
        //     name: 'X',
        //     href: '#',
        //     icon: (props: any) => (
        //         <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
        //             <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
        //         </svg>
        //     ),
        // },

        {
            name: 'YouTube',
            href: '#',
            brandColor: '#FF0000',
            icon: (props: any) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: 'Telegram',
            href: '#',
            brandColor: '#0088CC',
            icon: (props: any) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>

                    <path d="M19.2,4.4L2.9,10.7c-1.1,0.4-1.1,1.1-0.2,1.3l4.1,1.3l1.6,4.8c0.2,0.5,0.1,0.7,0.6,0.7c0.4,0,0.6-0.2,0.8-0.4
	                        c0.1-0.1,1-1,2-2l4.2,3.1c0.8,0.4,1.3,0.2,1.5-0.7l2.8-13.1C20.6,4.6,19.9,4,19.2,4.4z M17.1,7.4l-7.8,7.1L9,17.8L7.4,13l9.2-5.8
	                        C17,6.9,17.4,7.1,17.1,7.4z"/>
                </svg>
            ),
        },
        // {
        //     name: 'Viber',
        //     href: '#',
        //     icon: (props: any) => (
        //         <svg fill="currentColor" viewBox="0 0 24 24" {...props}>                    
        //             <path d="M19.3438 3.94922C18.8477 3.49219 16.8399 2.03516 12.3633 2.01562C12.3633 2.01562 7.08595 1.69922 4.51563 4.05859C3.08595 5.48828 2.58204 7.58594 2.52735 10.1836C2.47267 12.7812 2.40626 17.6484 7.09766 18.9687H7.10157L7.09766 20.9844C7.09766 20.9844 7.06641 21.8008 7.60548 21.9648C8.25391 22.168 8.63673 21.5469 9.25782 20.8789C9.59766 20.5117 10.0664 19.9727 10.4219 19.5625C13.6328 19.832 16.0977 19.2148 16.3789 19.125C17.0274 18.9141 20.6953 18.4453 21.2891 13.5781C21.9063 8.55469 20.9922 5.38281 19.3438 3.94922ZM19.8867 13.2109C19.3828 17.2734 16.4102 17.5312 15.8633 17.707C15.6289 17.7812 13.4609 18.3203 10.7383 18.1445C10.7383 18.1445 8.70704 20.5937 8.07423 21.2305C7.8672 21.4375 7.64063 21.418 7.64454 21.0078C7.64454 20.7383 7.66016 17.6602 7.66016 17.6602C7.65626 17.6602 7.65626 17.6602 7.66016 17.6602C3.6836 16.5586 3.91798 12.4141 3.96095 10.2461C4.00392 8.07812 4.41407 6.30078 5.62501 5.10547C7.80079 3.13281 12.2813 3.42578 12.2813 3.42578C16.0664 3.44141 17.8789 4.58203 18.3008 4.96484C19.6953 6.16016 20.4063 9.01953 19.8867 13.2109ZM14.457 10.0547C14.4727 10.3906 13.9688 10.4141 13.9531 10.0781C13.9102 9.21875 13.5078 8.80078 12.6797 8.75391C12.3438 8.73437 12.375 8.23047 12.707 8.25C13.7969 8.30859 14.4024 8.93359 14.457 10.0547ZM15.25 10.4961C15.2891 8.83984 14.2539 7.54297 12.2891 7.39844C11.957 7.375 11.9922 6.87109 12.3242 6.89453C14.5899 7.05859 15.7969 8.61719 15.7539 10.5078C15.75 10.8438 15.2422 10.8281 15.25 10.4961ZM17.0859 11.0195C17.0899 11.3555 16.582 11.3594 16.582 11.0234C16.5586 7.83984 14.4375 6.10547 11.8633 6.08594C11.5313 6.08203 11.5313 5.58203 11.8633 5.58203C14.7422 5.60156 17.0586 7.58984 17.0859 11.0195ZM16.6445 14.8516V14.8594C16.2227 15.6016 15.4336 16.4219 14.6211 16.1602L14.6133 16.1484C13.7891 15.918 11.8477 14.918 10.6211 13.9414C9.98829 13.4414 9.41016 12.8516 8.96485 12.2852C8.56251 11.7812 8.15626 11.1836 7.76173 10.4648C6.9297 8.96094 6.7461 8.28906 6.7461 8.28906C6.48438 7.47656 7.30079 6.6875 8.04688 6.26562H8.0547C8.41407 6.07812 8.75782 6.14062 8.98829 6.41797C8.98829 6.41797 9.47267 6.99609 9.6797 7.28125C9.87501 7.54687 10.1367 7.97266 10.2734 8.21094C10.5117 8.63672 10.3633 9.07031 10.1289 9.25L9.66017 9.625C9.42188 9.81641 9.45313 10.1719 9.45313 10.1719C9.45313 10.1719 10.1484 12.8008 12.7461 13.4648C12.7461 13.4648 13.1016 13.4961 13.293 13.2578L13.668 12.7891C13.8477 12.5547 14.2813 12.4062 14.707 12.6445C15.2813 12.9687 16.0117 13.4727 16.4961 13.9297C16.7695 14.1523 16.832 14.4922 16.6445 14.8516Z" />
        //         </svg>
        //     ),
        // },
    ],
}

export const Footer = ({ dictionary, lang, menu }: { dictionary: any, lang: string, menu: MenuWithItems }) => {
    const { data: session } = useSession();
    const serverDictionary = dictionary?.['server-component'] ?? {};
    const [currentUrl, setCurrentUrl] = useState('');
    const [canUseNavigatorShare, setCanUseNavigatorShare] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        setCurrentUrl(window.location.href);
        setCanUseNavigatorShare(typeof navigator !== 'undefined' && typeof navigator.share === 'function');
    }, []);

    useEffect(() => {
        if (!linkCopied) {
            return;
        }

        const timeout = window.setTimeout(() => setLinkCopied(false), 2000);
        return () => window.clearTimeout(timeout);
    }, [linkCopied]);

    const shareLinks = useMemo(() => {
        if (!currentUrl) {
            return [];
        }

        const encodedUrl = encodeURIComponent(currentUrl);
        return [
            {
                name: 'Facebook',
                href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
                brandColor: '#1877F2',
                icon: (props: any) => (
                    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                        <path
                            fillRule="evenodd"
                            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                            clipRule="evenodd"
                        />
                    </svg>
                ),
            },
            {
                name: 'LinkedIn',
                href: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`,
                brandColor: '#0A66C2',
                icon: (props: any) => (
                    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                        <path d="M4.98 3.5A2.5 2.5 0 1 1 5 8.5a2.5 2.5 0 0 1-.02-5zM3 9h3.96v12H3zm7.47 0H14v1.71h.05c.55-1.04 1.9-2.13 3.91-2.13 4.18 0 4.95 2.75 4.95 6.33V21H19v-5.32c0-1.27-.02-2.91-1.77-2.91-1.77 0-2.04 1.38-2.04 2.81V21h-4.72z" />
                    </svg>
                ),
            },
            {
                name: 'Telegram',
                href: `https://t.me/share/url?url=${encodedUrl}`,
                brandColor: '#0088CC',
                icon: (props: any) => (
                    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                        <path d="M19.2 4.4 2.9 10.7c-1.1.4-1.1 1.1-.2 1.3l4.1 1.3 1.6 4.8c.2.5.1.7.6.7.4 0 .6-.2.8-.4.1-.1 1-1 2-2l4.2 3.1c.8.4 1.3.2 1.5-.7l2.8-13.1c.5-.9-.2-1.5-.9-1.1zm-2.1 3-7.8 7.1-.3 3.3-1.6-4.8 9.2-5.8c.4-.3.8-.1.5.2z" />
                    </svg>
                ),
            },
            {
                name: 'X',
                href: `https://twitter.com/intent/tweet?url=${encodedUrl}`,
                brandColor: '#1D9BF0',
                icon: (props: any) => (
                    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                        <path d="M18.244 2.25h3.213l-7.01 8.004 8.263 11.246H16.17l-4.827-6.318-5.522 6.318H2.607l7.482-8.558L2.13 2.25h6.205l4.348 5.736 5.561-5.736Zm-1.131 17.52h1.78L6.963 4.626H5.048z" />
                    </svg>
                ),
            },
        ];
    }, [currentUrl]);

    const handleNativeShare = useCallback(async () => {
        if (!canUseNavigatorShare || !currentUrl) {
            return;
        }

        try {
            await navigator.share({ url: currentUrl });
        } catch (error) {
            console.error('Native share failed', error);
        }
    }, [canUseNavigatorShare, currentUrl]);

    const handleCopyLink = useCallback(async () => {
        if (!currentUrl) {
            return;
        }

        try {
            await navigator.clipboard.writeText(currentUrl);
            setLinkCopied(true);
        } catch (error) {
            console.error('Copy link failed', error);
        }
    }, [currentUrl]);

    const buildMenu = useCallback((item: NavItemWithTranslates, level: number) => {
        if (!item || item.hide) {
            return null;
        }

        if (!menu || !menu.navitems) {
            return null;
        }

        const children = menu?.navitems
            .filter((child) => child.parentid === item.id && !child.hide)
            .sort((a: NavItemWithTranslates, b: NavItemWithTranslates) => a.stack - b.stack);

        if (!children || children.length === 0) {
            if (level === 0) {
                return (
                    <div key={item.id} className="space-y-2">
                        <NextLink
                            className="text-sm font-semibold uppercase tracking-wide text-gray-300 transition hover:text-white dark:text-gray-400 dark:hover:text-white"
                            href={`/${lang}${item.href}`}
                        >
                            {item.translates?.length > 0 ? item.translates[0].title : item.title}
                        </NextLink>
                    </div>
                );
            }

            return (
                <NextLink
                    key={item.id}
                    className="text-sm text-gray-400 transition hover:text-gray-100 dark:text-gray-500 dark:hover:text-gray-200"
                    href={`/${lang}${item.href}`}
                >
                    {item.translates?.length > 0 ? item.translates[0].title : item.title}
                </NextLink>
            );
        }

        return (
            <div key={item.id} className="space-y-3">
                <NextLink
                    className="text-sm font-semibold uppercase tracking-wide text-gray-300 transition hover:text-white dark:text-gray-400 dark:hover:text-white"
                    href={`/${lang}${item.href}`}
                >
                    {item.translates?.length > 0 ? item.translates[0].title : item.title}
                </NextLink>
                <div className="flex flex-col gap-2 pl-1">
                    {children.map((child: NavItemWithTranslates) => buildMenu(child, level + 1))}
                </div>
            </div>
        );
    }, [lang, menu?.navitems]);

    const footerColumns = useMemo(() => {
        const rootItems = menu?.navitems
            ?.filter((item) => item.parentid === null && !item.hide)
            .sort((a, b) => a.stack - b.stack);

        return rootItems?.map((item) => buildMenu(item as NavItemWithTranslates, 0));
    }, [buildMenu, menu?.navitems]);

    return (
        <footer className="bg-neutral-900 text-gray-100 dark:bg-neutral-950 pb-32 sm:pb-4">
            <div className="mx-auto max-w-7xl px-6 pb-10 pt-16 sm:px-8 lg:px-12">
                <div className="flex flex-col gap-12 xl:flex-row xl:items-start xl:justify-between">
                    <div className="max-w-xl space-y-8">
                        <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
                            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white/5 p-2 sm:h-16 sm:w-16">
                                <BlazonWhiteIcon />
                            </div>
                            <div className="space-y-1 sm:space-y-2 sm:max-w-xl">
                                <p className="text-sm font-medium text-gray-200">
                                    {serverDictionary.ministry_agrarian_policy_food_ukraine}
                                </p>
                                <p className="text-xs pt-2 uppercase tracking-wide text-gray-400">
                                    {serverDictionary.paing_agancy_footer ?? 'Paying Agency'}
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-wrap items-center gap-4 text-gray-400">
                            <div className="flex items-center gap-3">
                                <img src={flagEU.src} alt="EU Flag" className="h-10 w-10 rounded-full object-cover" />
                                <img src={flagUA.src} alt="Ukraine Flag" className="h-10 w-10 rounded-full object-cover" />
                            </div>
                            <div className="flex items-center gap-4">
                                {navigation.social.map((item) => (
                                    <a
                                        key={item.name}
                                        href={item.href}
                                        className="transition hover:text-white"
                                        style={{ color: item.brandColor ?? undefined }}
                                        aria-label={item.name}
                                    >
                                        <item.icon aria-hidden="true" className="h-6 w-6" />
                                    </a>
                                ))}
                            </div>
                            <div className="flex flex-col gap-2 text-gray-400">
                                <span className="text-xs uppercase tracking-wide text-gray-500">
                                    {serverDictionary.share_this_page ?? 'Share this page'}
                                </span>
                                <div className="flex flex-wrap items-center gap-3">
                                    {canUseNavigatorShare && (
                                        <button
                                            type="button"
                                            onClick={handleNativeShare}
                                            className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-gray-200 transition hover:bg-white/20"
                                            aria-label={serverDictionary.share_via_device ?? 'Share via browser'}
                                        >
                                            <span className="material-symbols-outlined text-xl">ios_share</span>
                                        </button>
                                    )}
                                    {shareLinks.map((item) => (
                                        <a
                                            key={item.name}
                                            href={item.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition hover:bg-white/20"
                                            style={{ color: item.brandColor ?? undefined }}
                                            aria-label={item.name}
                                        >
                                            <item.icon aria-hidden="true" className="h-5 w-5" />
                                        </a>
                                    ))}
                                    <button
                                        type="button"
                                        onClick={handleCopyLink}
                                        className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-gray-200 transition hover:bg-white/20"
                                        aria-label={serverDictionary.copy_link ?? 'Copy link'}
                                    >
                                        <span className="material-symbols-outlined text-xl">link</span>
                                    </button>
                                </div>
                                {linkCopied && (
                                    <span className="text-xs text-emerald-400">
                                        {serverDictionary.link_copied ?? 'Link copied to clipboard'}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <nav
                        aria-label={serverDictionary.footer_navigation || 'Footer navigation'}
                        className="grid w-full gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:max-w-3xl"
                    >
                        {footerColumns?.filter(Boolean).map((column, index) => (
                            <div key={`footer-column-${index}`} className="space-y-3 text-sm text-gray-400">
                                {column}
                            </div>
                        ))}
                    </nav>
                </div>

                <div className="mt-12 grid gap-8 border-t border-white/10 pt-8 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
                    <div className="flex flex-wrap items-center justify-center gap-6 sm:justify-start">                        
                        <a
                            href="#"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex h-12 items-center"
                            aria-label="EU4SmallFarms"
                            title="EU4SmallFarms"
                        >
                            <img
                                src="/files/images/pages/homepage/eu4smallfarms.png"
                                alt="EU4SmallFarms"
                                className="h-12 object-contain"
                            />
                        </a>
                        <a
                            href="https://www.niras.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex h-12 w-28 items-center"
                            aria-label="NIRAS"
                            title="NIRAS"
                        >
                            <Niras />
                        </a>
                    </div>

                    <div className="flex flex-row items-center justify-center sm:justify-end gap-6 sm:gsp-4">
                        <ThemeSwitch />
                        <Link href={`/${lang}/faq`} aria-label="Help Center" title="Help Center &amp; User Guide">
                            <span className="material-symbols-outlined text-2xl text-gray-300 transition hover:text-white">help</span>
                        </Link>
                        {session ? (
                            <SignOutButton redirectTo={`/${lang}`} variant='light'>
                                <span className="material-symbols-outlined text-2xl text-gray-300 transition hover:text-white">person_check</span>
                            </SignOutButton>
                        ) : (
                            <>
                                <Link href={`/${lang}/auth/signin`} aria-label="Sign in">
                                    <span className="material-symbols-outlined text-2xl text-gray-300 transition hover:text-white">person</span>
                                </Link>
                                <Link href={`/${lang}/auth/register`} aria-label="Register">
                                    <span className="material-symbols-outlined text-2xl text-gray-300 transition hover:text-white">person_add</span>
                                </Link>
                            </>
                        )}
                    </div>
                </div>

                    <div className="mt-10 border-t border-white/10 pt-6 text-center text-xs text-gray-500">
                    © {new Date().getFullYear()}{' '}
                    <Link href={`/${lang}`} className="transition hover:text-white">
                        {siteConfig.caption}
                    </Link>{' '}
                        {serverDictionary.all_rights_reserved ?? 'All rights reserved.'}
                </div>
            </div>
        </footer>
    );
}


export default Footer;